<template>
  <div class="modal-mask" @mousedown.self.stop="closeModal()">
    <div class="modal" @click.stop>
      <div class="modal__head">
        <h3 class="modal__title">Удалить чат</h3>
        <div class="close" @click.stop="closeModal()">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
            <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
      </div>
      <div class="modal__body">
        <p class="modal__text">Вы действительно хотите удалить чат?</p>
        <div class="modal__button-wrap">
          <div class="modal__button" v-if="items.remove">
            <AppButton title="Да" type="main" @click.native="remove" />
          </div>
          <div class="modal__button">
            <AppButton title="Нет" type="alt" @click.native="closeModal" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '../button/AppButton.vue'

export default {
  name: 'dialog-room-modal',
  components: {
    AppButton
  },
  props: {
    items: {
      type: Object,
      default: () => ({ select: false, pin: false, update: false, reply: false, task: false, remove: true })
    },
    state: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {

  },
  methods: {
    closeModal () {
      this.$emit('close-modal')
    },
    remove () {
      this.$emit('remove-item')
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.modal-mask {
  position: absolute;
  display: block;
  top: 0;
  right: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.6);
}

.modal {
  position: absolute;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  max-width: 480px;

  @media screen and (max-width: $tablet_start) {
    top: 0;
    left: 0;
    right: 0;
    transform: translateX(0);
  }

  &__body {
    width: 100%;
    padding: 0 20px 40px;
  }

  &__text {
    text-align: center;
    color: $font_color_second;
    margin-bottom: 20px;
  }

  &__button-wrap {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
  }

  &__button {
    margin-right: 16px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
